// extracted by mini-css-extract-plugin
module.exports = {"Index":"Liebiao_Index__bduE6","banmian":"Liebiao_banmian__2CFIK","banmianTitle":"Liebiao_banmianTitle__TqFJx"};